import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { FIREBASE_CONFIG } from "config";

const app = initializeApp(FIREBASE_CONFIG);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
